// src/utils/request.js
import axios from 'axios'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,  // '/dev-api'
  timeout: 10000
})

// 请求拦截器 - 关键：每次请求自动加 token
service.interceptors.request.use(
  config => {
    // 从 localStorage 获取 token
    const token = localStorage.getItem('userToken')
    
    // 如果有 token，加到请求头
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
      // 或者你的后端需要其他格式：
      // config.headers['token'] = token
      // config.headers['X-Token'] = token
    }
    
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // 401 处理
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('userToken')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default service